
import { v4 as uuidv4 } from "uuid";
import {
  UpgradableNumber
} from "@dndModels";

export class DiceRollUpgradable {
  true_id: string;
  size: UpgradableNumber;
  count: UpgradableNumber;

  constructor(obj?: any) {
    this.true_id = obj && obj.true_id ? obj.true_id : uuidv4().toString();
    this.size = obj ? new UpgradableNumber(obj.size) : new UpgradableNumber();
    this.count = obj ? new UpgradableNumber(obj.count) : new UpgradableNumber();
  }

  toDBObj(): any {
    return {
      true_id: this.true_id,
      size: this.size.toDBObj(),
      count: this.count.toDBObj(),
    };
  }

  copy(copyMe: DiceRollUpgradable, drop_ids: boolean): void {
    if (!drop_ids) {
      this.true_id = copyMe.true_id;
    }
    this.size = copyMe.size.clone();
    this.count = copyMe.count.clone();
  }

  clone(drop_ids: boolean): DiceRollUpgradable {
    const new_obj = new DiceRollUpgradable();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }
}